import { motion } from "framer-motion";

const Tag = ({ label, color, onRemove }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -6 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.85 }}
      transition={{ duration: 0.15 }}
      className={`flex items-center ${color.bg} ${color.text} px-2 py-1 
                  rounded-full text-sm mr-2 mt-1 shadow-sm`}
    >
      {label}

      <button
        onClick={onRemove}
        className={`ml-2 opacity-70 hover:opacity-100 transition ${color.hover}`}
      >
        &times;
      </button>
    </motion.div>
  );
};

export default Tag;
